<template>
    <a-spin :spinning="isLoading" size="large">
        <div class="spin-content">
            <a-card 
                :bordered="false" 
                class="euclid-table-card header-solid h-full c_official_card_body" 
                :bodyStyle="{padding: 0,}" 
            >
                <template #title>
                    <a-row type="flex" align="middle">
                        <a-col :span="12" :xl="4" :md="12" :sm="8">
                            <h5 class="font-semibold m-0">{{ $t('page-titles.officials') }}</h5>
                        </a-col>
                        <a-col :span="12" :xl="4" :md="4" :sm="8" >
                            <a-button type="primary" @click.prevent="navigateTo('CreateOfficial')">
                                {{ $t('officials-page.create-button-title') }}
                            </a-button>
                        </a-col>
                        <a-col :span="38" :md="18" style="display: flex; align-items: center; justify-content: flex-end">
                            <!-- <a-radio-group v-model="authorsHeaderBtns" size="small">
                                <a-radio-button value="active">ACTIVE</a-radio-button>
                                <a-radio-button value="inactive">INACTIVE</a-radio-button>
                                <a-radio-button value="all">ALL</a-radio-button>
                            </a-radio-group> -->
                        </a-col>
                    </a-row>
                </template>

                <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="id">
                    <template slot="official" slot-scope="group1">
                        <div class="table-avatar-info">
                            <a-avatar shape="square" :src="group1.imageUrl" />
					        <div class="avatar-info">
						        <h6 v-show="locale == 'en'">{{ group1.name }}</h6>
						        <h6 v-show="locale == 'bn'">{{ group1.nameBn }}</h6>
						        <p v-show="locale == 'en'">{{ group1.designation }}</p>
						        <p v-show="locale == 'bn'">{{ group1.designationBn }}</p>
					        </div>      
                        </div>
                    </template>
                    <template slot="phone" slot-scope="group2">
                        <div class="table-avatar-info">
                            <div class="avatar-info">
						        <h6>{{ group2.email }}</h6>
						        <p>{{ group2.mobile }}</p>
					        </div>      
                        </div>
                    </template>

                    <!-- "status ? 'ant-tag-primary' : 'ant-tag-muted'" -->
                   <template slot="status" slot-scope="status">
                        <a-tag class="tag-status ant-tag-primary" :style="{'background-color': (status == 'ACTIVE'? '#0069ff':'red')}">
                            {{ status }}
                        </a-tag>
                    </template>

                    <template slot="editBtn" slot-scope="row">
                        <a-tooltip>
                            <a-button 
                                type="primary" 
                                shape="circle" 
                                @click="navigateTo('EditOfficial',{},{id:row.id})" 
                                icon="edit" 
                                :data-id="row.key"
                            >
                            </a-button>
                            <template slot="title">
                                {{$t('tool-tip.edit')}}
                            </template>
                        </a-tooltip>
                    </template>


                    <template slot="resetPassBtn" slot-scope="row" >
                        <a-tooltip>
                            <a-button 
                                v-show="hasRoleAnyOf(['OWNER', 'ICT'])"
                                type="danger" 
                                shape="circle" 
                                @click.prevent="$refs.resetPasswordModal.showModal(row.userId)"
                                icon="sync" 
                                :data-id="row.key"
                            >
                            </a-button>
                            <template slot="title">
                                {{$t('tool-tip.reset-password')}}
                            </template>
                        </a-tooltip>
                    </template>

                   

                    <!-- <template slot="deleteBtn" slot-scope="row">
                        <a-tooltip>
                            <template slot="title">
                                delete
                            </template>
                            <a-button type="danger" shape="circle" icon="delete" :data-id="row.key">
                            </a-button>
                            
                        </a-tooltip>
                        
                    </template> -->

                </a-table>
            </a-card>
             <ResetPasswordModal
                ref="resetPasswordModal"
            >
            </ResetPasswordModal>
        </div>
    </a-spin>
</template>

<script>


import { mapState } from 'pinia';
import { host, officialsClient } from '../../api/config';	
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import { useLocaleStore } from '../../stores/locale-store';
import ResetPasswordModal from "../modal/ResetPassword.vue";
import { useAuthStore } from "../../stores/auth-store.js";

export default ({
    components: {
        ResetPasswordModal,
    },
    mixins: [ navigationMixin ],
    data() {
        return {
            userId: "",
            data: [],
            isLoading: true,
            authorsHeaderBtns: 'active',
            columns: [
                {
                    title: this.$t('table-headers.official'),
                    dataIndex: 'group1',
                    scopedSlots: { customRender: 'official' },
                    width: 300,
                },
                {
                    title: this.$t('table-headers.contact'),
                    dataIndex: 'group2',
                    scopedSlots: { customRender: 'phone' },
                },
                {
                    title: this.$t('table-headers.status'),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                },
                {
                    title: '',
                    scopedSlots: { customRender: 'viewBtn' },
                    width: 50,
                },
                {
                    title: this.$t('table-headers.actions'),
                    scopedSlots: { customRender: 'editBtn' },
                    width: 10,
                },
                {
                    title: '',
                    scopedSlots: { customRender: 'resetPassBtn' },
                    width: 10,
                },
                {
                    title: '',
                    scopedSlots: { customRender: 'deleteBtn' },
                    width: 10,
                },
                
            ]
        }
    },
    computed: {
        ...mapState(useLocaleStore, [ 'locale' ]),
        ...mapState(useAuthStore, [ 'currentUser' ]),
        roles() {
            return this.currentUser.roles || [];
        }
    },
    methods:{
        hasRoleAnyOf(roles) {
            return this.roles.filter(r => roles.indexOf(r) !== -1).length > 0;
        },
    },
    watch: {
        locale() {
            this.columns[0].title = this.$t('table-headers.official');
            this.columns[1].title = this.$t('table-headers.contact');
            this.columns[2].title = this.$t('table-headers.status');
            this.columns[4].title = this.$t('table-headers.actions');
        }
    },
    mounted() {
        this.isLoading = true;
        officialsClient.fetchAllOfPage({ page: 1, size: 200 }).then(res => {
            if (!res.networkError && res.status == 200 && res.body.list) {
                console.log(res.body.list);
                res.body.list.forEach(o => {
                    if (o.imageUrl && o.imageUrl.length > 0) {
                        o.imageUrl = host + o.imageUrl;
                    } else {
                        o.imageUrl = '/images/default-avatar.jpg';
                    }
                    o.group1 = {
                        'imageUrl': o.imageUrl,
                        'name': o.name,
                        'nameBn': o.nameBn,
                        'designation': o.designation.name,
                        'designationBn': o.designation.nameBn
                    },
                    o.group2 = {
                        'email': o.email,
                        'mobile': o.mobile,
                    }
                })
                this.data = res.body.list;
            }
            this.isLoading = false;
        });
    }
})

</script>